/* Tapestry Brew Guide
 * Two paths: a starting recipe ("new") or step-by-step troubleshooting ("fix").
 * Coffees come from the section's JSON (built from your published products).
 * Brewing knowledge lives in tapestry-brew-data.js; this file only runs the experience.
 */
(function () {
  'use strict';

  var D = window.TapestryBrewData;
  if (!D) return;

  var LAST_KEY = 'tbg_last_v1';
  var SAVED_KEY = 'tbg_saved_v1';
  var OPP = { finer: 'coarser', coarser: 'finer', longer: 'shorter', shorter: 'longer', stronger: 'weaker', weaker: 'stronger', hotter: 'cooler', cooler: 'hotter' };
  var KIND_ORDER = { blend: 0, single: 1, coffee: 2, decaf: 3 };

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function byId(list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return null; }
  function num(v) { var n = parseFloat(String(v == null ? '' : v).replace(',', '.')); return isFinite(n) && n > 0 ? n : null; }
  function parseTime(v) {
    if (v == null || v === '') return null;
    var m = String(v).trim().match(/^(\d{1,2})[:.](\d{1,2})$/);
    if (m) return Number(m[1]) * 60 + Number(m[2]);
    var n = num(v);
    if (n === null) return null;
    return n < 15 ? Math.round(n * 60) : Math.round(n); // "3.5" means minutes, "210" means seconds
  }
  function store(kind, key, val) {
    try {
      var s = window[kind];
      if (val === undefined) return JSON.parse(s.getItem(key) || 'null');
      if (val === null) s.removeItem(key); else s.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }
  function splitNotes(str) {
    if (!str) return [];
    return String(str).replace(/\s+and\s+/gi, ', ').replace(/\s*&\s*/g, ', ').replace(/[;.]/g, ',')
      .split(',').map(function (x) { return x.trim(); }).filter(Boolean).slice(0, 3);
  }

  function track(name, data) {
    data = data || {};
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, data);
      else (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data));
    } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }

  /* ======================================================================== */

  function Guide(root) {
    this.root = root;
    this.view = $(root, '[data-tbg-view]');
    this.live = $(root, '[data-tbg-live]');
    try { this.coffees = JSON.parse($(root, '[data-tbg-coffees]').textContent) || []; } catch (e) { this.coffees = []; }
    try { this.cfg = JSON.parse($(root, '[data-tbg-settings]').textContent) || {}; } catch (e) { this.cfg = {}; }
    this.coffees.forEach(function (c) {
      if (typeof c.brew === 'string') { try { c.brew = JSON.parse(c.brew); } catch (e) { c.brew = null; } }
      if (!c.brew || typeof c.brew !== 'object') c.brew = {};
    });
    var rank = function (c) { return KIND_ORDER.hasOwnProperty(c.kind) ? KIND_ORDER[c.kind] : 2; };
    this.coffees.sort(function (a, b) { return rank(a) - rank(b); });
    this.reset();
    this.stack = [];
    this.started = false;
    this.bindHistory();
    if (!this.fromUrl()) this.go('home', { replace: true });
  }

  Guide.prototype.reset = function () {
    this.s = { path: null, coffee: null, roast: null, method: null, machine: null, basket: null, grinder: null, brewer: null, symptom: null, d: {}, size: null };
    this.resetFix();
  };
  Guide.prototype.resetFix = function () {
    this.fx = { attempts: [], tried: {}, repeats: {}, dirs: [], current: null, repeat: false, split: null };
  };

  /* ---------- lookups ---------- */
  Guide.prototype.coffee = function () {
    var h = this.s.coffee;
    if (!h || h === 'other') return null;
    for (var i = 0; i < this.coffees.length; i++) if (this.coffees[i].handle === h) return this.coffees[i];
    return null;
  };
  Guide.prototype.coffeeName = function () {
    var c = this.coffee();
    if (c) return c.title;
    if (this.s.coffee === 'other') {
      var r = byId(D.ROASTS, this.s.roast);
      return r && r.id !== 'unknown' ? 'Your coffee (' + r.label.toLowerCase() + ')' : 'Your coffee';
    }
    return '';
  };
  Guide.prototype.roastValue = function () {
    var c = this.coffee();
    if (c) return c.roast;
    var r = byId(D.ROASTS, this.s.roast);
    return r ? r.roast : 3;
  };
  Guide.prototype.machine = function () { return byId(D.MACHINES, this.s.machine); };
  Guide.prototype.grinder = function () {
    var m = this.machine();
    if (this.s.method === 'espresso' && m && m.grinder === 'builtin') return 'builtin';
    return this.s.grinder;
  };
  Guide.prototype.methodLabel = function () { var m = byId(D.METHODS, this.s.method); return m ? m.label : ''; };
  Guide.prototype.equipLabel = function () {
    if (this.s.method === 'espresso' && this.machine() && this.s.machine !== 'other') return this.machine().label;
    if (this.s.method === 'pourover' && this.s.brewer && this.s.brewer !== 'other') return byId(D.BREWERS, this.s.brewer).label;
    return '';
  };
  Guide.prototype.override = function () {
    var c = this.coffee();
    if (!c || !c.brew.recipes) return {};
    var r = c.brew.recipes;
    return (this.s.brewer && r[this.s.method + ':' + this.s.brewer]) || r[this.s.method] || {};
  };
  Guide.prototype.roasterNote = function () {
    var c = this.coffee();
    if (!c) return '';
    var o = this.override();
    if (o.note) return o.note;
    return (c.brew.notes && c.brew.notes[this.s.method]) || '';
  };
  Guide.prototype.isRecommended = function (methodId) {
    var c = this.coffee();
    return !!(c && c.brew.recommended && c.brew.recommended.indexOf(methodId) !== -1);
  };
  Guide.prototype.sizeCfg = function () {
    var r = D.RECIPES[this.s.method];
    if (!r || !r.size) return null;
    var max = typeof r.size.max === 'function' ? r.size.max(this.s) : r.size.max;
    return { label: r.size.label, min: r.size.min, max: max, def: r.size.def, unit: r.size.unit };
  };
  Guide.prototype.recipe = function () {
    var r = D.RECIPES[this.s.method];
    var sz = this.sizeCfg();
    var size = sz ? Math.min(Math.max(this.s.size || sz.def, sz.min), sz.max) : 1;
    var o = this.override();
    var out = r.build({ roast: this.roastValue(), brewer: this.s.brewer, machine: this.machine(), size: size, o: o });
    out.tested = !!o.tested;
    out.size = size;
    return out;
  };

  /* ---------- flow ---------- */
  Guide.prototype.flow = function () {
    var s = this.s, f = ['coffee'];
    if (s.coffee === 'other') f.push('roast');
    f.push('method');
    if (s.path === 'new') {
      if (s.method === 'espresso') f.push('machine');
      if (s.method === 'pourover') f.push('brewer');
      f.push('recipe');
    } else {
      if (s.method === 'espresso') { f.push('machine', 'basket'); if (this.grinder() !== 'builtin') f.push('grinder'); }
      else if (s.method === 'pourover') f.push('brewer', 'grinder');
      else if (s.method) f.push('grinder');
      f.push('symptom', 'details', 'fix');
    }
    return f;
  };
  Guide.prototype.answered = function (screen) {
    var s = this.s;
    switch (screen) {
      case 'coffee': return !!s.coffee;
      case 'roast': return !!s.roast;
      case 'method': return !!s.method;
      case 'machine': return !!s.machine;
      case 'basket': return !!s.basket;
      case 'grinder': return !!s.grinder;
      case 'brewer': return !!s.brewer;
      case 'symptom': return !!s.symptom;
      case 'details': return !!s.dSeen;
      default: return false;
    }
  };
  Guide.prototype.firstOpen = function () {
    var f = this.flow();
    for (var i = 0; i < f.length; i++) if (!this.answered(f[i])) return f[i];
    return f[f.length - 1];
  };
  Guide.prototype.next = function (from) {
    var f = this.flow();
    var i = f.indexOf(from);
    var target = i === -1 ? this.firstOpen() : f[i + 1];
    // Skip ahead past steps already answered only when they were filled in for us (e.g. from a product page link)
    while (target && this.prefilled && this.prefilled[target] && this.answered(target)) target = f[f.indexOf(target) + 1];
    if (target === 'fix') return this.startFix();
    this.go(target || 'home');
  };

  /* ---------- history ---------- */
  Guide.prototype.bindHistory = function () {
    var self = this;
    window.addEventListener('popstate', function (e) {
      var st = e.state && e.state.tbg;
      if (!st) return;
      if (st < self.stack.length) {
        self.stack.length = st;
        self.render(self.stack[st - 1], true);
      }
    });
  };
  Guide.prototype.go = function (screen, opts) {
    opts = opts || {};
    if (opts.replace && this.stack.length) this.stack[this.stack.length - 1] = screen;
    else this.stack.push(screen);
    try {
      var url = this.urlFor(screen);
      if (opts.replace || this.stack.length === 1) history.replaceState({ tbg: this.stack.length }, '', url);
      else history.pushState({ tbg: this.stack.length }, '', url);
    } catch (e) {}
    this.render(screen);
  };
  // Jump to a screen deep in the flow with every earlier step in history, so Back works as expected.
  Guide.prototype.goPath = function (screen) {
    var f = this.flow(), i = f.indexOf(screen);
    var trail = i === -1 ? [screen] : f.slice(0, i + 1).filter(function (x) { return x !== 'fix' || x === screen; });
    if (i === -1 && screen === 'changed') trail = f.slice(0, f.indexOf('fix') + 1).concat('changed');
    this.stack = ['home'];
    try { history.replaceState({ tbg: 1 }, '', location.pathname + location.search); } catch (e) {}
    for (var k = 0; k < trail.length - 1; k++) {
      this.stack.push(trail[k]);
      try { history.pushState({ tbg: this.stack.length }, '', this.urlFor(trail[k])); } catch (e) {}
    }
    this.go(trail[trail.length - 1]);
  };
  Guide.prototype.back = function () {
    if (this.stack.length > 1) {
      try { history.back(); return; } catch (e) {}
      this.stack.pop();
      this.render(this.stack[this.stack.length - 1], true);
    }
  };
  Guide.prototype.urlFor = function (screen) {
    var base = location.pathname;
    if (screen !== 'recipe') return base + (this.keepParams || '');
    var s = this.s, q = [];
    if (s.coffee) q.push('coffee=' + encodeURIComponent(s.coffee));
    if (s.coffee === 'other' && s.roast) q.push('roast=' + s.roast);
    q.push('method=' + s.method);
    if (s.method === 'espresso' && s.machine) q.push('machine=' + s.machine);
    if (s.method === 'pourover' && s.brewer) q.push('brewer=' + s.brewer);
    if (s.size) q.push('size=' + s.size);
    return base + '?' + q.join('&');
  };
  Guide.prototype.shareUrl = function () { return location.origin + this.urlFor('recipe'); };

  Guide.prototype.fromUrl = function () {
    var p = {};
    location.search.replace(/^\?/, '').split('&').forEach(function (kv) {
      if (!kv) return;
      var i = kv.indexOf('=');
      p[decodeURIComponent(kv.slice(0, i === -1 ? kv.length : i))] = i === -1 ? '' : decodeURIComponent(kv.slice(i + 1).replace(/\+/g, ' '));
    });
    var s = this.s, ok = false;
    this.prefilled = {};
    if (p.coffee && (p.coffee === 'other' || this.coffees.some(function (c) { return c.handle === p.coffee; }))) { s.coffee = p.coffee; this.prefilled.coffee = true; ok = true; }
    if (p.roast && byId(D.ROASTS, p.roast)) { s.roast = p.roast; this.prefilled.roast = true; }
    if (p.method && byId(D.METHODS, p.method)) { s.method = p.method; this.prefilled.method = true; }
    if (p.machine && byId(D.MACHINES, p.machine)) { s.machine = p.machine; this.prefilled.machine = true; }
    if (p.brewer && byId(D.BREWERS, p.brewer)) { s.brewer = p.brewer; this.prefilled.brewer = true; }
    if (num(p.size)) s.size = Math.round(num(p.size));
    if (p.path === 'fix' || p.path === 'new') s.path = p.path;

    if (ok && (s.path || s.method)) {
      this.started = true;
      track('brew_guide_started', { source: s.method ? 'shared_link' : 'product_page', coffee: s.coffee });
      if (s.path) track('brew_guide_path_selected', { path: s.path, source: 'link' });
    }
    if (s.method && s.coffee && s.path !== 'fix') {
      s.path = 'new';
      if (this.firstOpen() === 'recipe') {
        this.stack = ['home'];
        try { history.replaceState({ tbg: 1 }, '', location.pathname); } catch (e) {}
        this.go('recipe');
        return true;
      }
    }
    if (s.path && ok) { this.stack = ['home']; try { history.replaceState({ tbg: 1 }, '', location.pathname + location.search); } catch (e) {} this.go(this.firstOpen()); return true; }
    if (ok) { this.go('home', { replace: true }); return true; }
    return false;
  };

  /* ---------- rendering ---------- */
  Guide.prototype.render = function (screen, isBack) {
    var html = '';
    var fn = this['screen_' + screen] || this.screen_home;
    this.screen = screen;
    html = fn.call(this);
    this.view.innerHTML = '<div class="tbg__screen' + (isBack ? ' is-back' : '') + '" data-screen="' + screen + '">' + html + '</div>';
    this.wire(screen);
    this.root.classList.toggle('is-home', screen === 'home');
    if (screen !== 'home') this.remember(screen);
    var h = $(this.view, '[data-focus]');
    if (h && this.hasRendered) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
    if (this.hasRendered) this.scrollIntoView();
    this.hasRendered = true;
  };
  Guide.prototype.scrollIntoView = function () {
    var top = this.root.getBoundingClientRect().top;
    if (top < -10 || top > window.innerHeight * 0.5) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: window.scrollY + top - 80, behavior: reduce ? 'auto' : 'smooth' });
    }
  };
  Guide.prototype.remember = function (screen) {
    if (screen === 'success' || screen === 'stop') { store('localStorage', LAST_KEY, null); return; }
    store('localStorage', LAST_KEY, { s: this.s, fx: this.fx, screen: screen, at: Date.now() });
  };

  Guide.prototype.icon = function (key) {
    var u = this.cfg.icons && this.cfg.icons[key];
    return u ? '<img class="tbg__icon" src="' + esc(u) + '" alt="" width="56" height="56" loading="lazy">' : '';
  };

  Guide.prototype.top = function (screen) {
    var f = this.flow();
    var steps = f.slice(0, -1);
    var i = steps.indexOf(screen);
    var pct = i === -1 ? 100 : Math.round(((i + 1) / (steps.length + 1)) * 100);
    var h = '<div class="tbg__top"><button type="button" class="tbg__back" data-back aria-label="Go back"><span aria-hidden="true">←</span> Back</button>';
    h += '<div class="tbg__progress" role="progressbar" aria-label="Progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div></div>';
    return h + this.summary(screen);
  };

  Guide.prototype.summary = function (current) {
    var s = this.s, chips = [];
    var push = function (screen, label) { if (label) chips.push('<button type="button" class="tbg__crumb" data-jump="' + screen + '"' + (screen === current ? ' aria-current="step"' : '') + '>' + esc(label) + '</button>'); };
    if (s.coffee) push('coffee', this.coffeeName());
    if (s.method) push('method', this.methodLabel());
    if (s.method === 'espresso' && s.machine) push('machine', this.machine().label);
    if (s.method === 'pourover' && s.brewer) push('brewer', byId(D.BREWERS, s.brewer).label);
    if (s.path === 'fix' && s.symptom && current !== 'symptom') push('symptom', this.symptomLabel(s.symptom));
    if (!chips.length) return '';
    return '<div class="tbg__crumbs" aria-label="Your answers. Select one to change it.">' + chips.join('') + '</div>';
  };

  Guide.prototype.question = function (screen, title, hint, opts, current, grid) {
    var h = this.top(screen) + '<h2 class="tbg__q" tabindex="-1" data-focus>' + esc(title) + '</h2>';
    if (hint) h += '<p class="tbg__hint">' + esc(hint) + '</p>';
    h += '<div class="tbg__opts' + (grid ? ' is-grid' : '') + '" role="list">';
    opts.forEach(function (o) {
      var on = current === o.id;
      h += '<div role="listitem"><button type="button" class="tbg__opt' + (on ? ' is-on' : '') + (o.icon ? ' has-icon' : '') + '" data-pick="' + esc(o.id) + '" aria-pressed="' + on + '">' +
        (o.icon || '') + '<span class="tbg__optbody"><span class="tbg__optlabel">' + esc(o.label) + '</span>' +
        (o.sub ? '<span class="tbg__optsub">' + esc(o.sub) + '</span>' : '') + '</span>' +
        (o.badge ? '<span class="tbg__flag">' + esc(o.badge) + '</span>' : '') + '</button></div>';
    });
    return h + '</div>';
  };

  /* ---------- screens ---------- */
  Guide.prototype.screen_home = function () {
    var c = this.coffee(), cfg = this.cfg;
    var h = '<div class="tbg__intro">';
    if (cfg.eyebrow) h += '<div class="tbg__eyebrow">' + esc(cfg.eyebrow) + '</div>';
    h += '<h1 class="tbg__title" tabindex="-1" data-focus>' + esc(c ? 'Let\'s brew ' + c.title + '.' : (cfg.heading || 'Let\'s dial in your cup.')) + '</h1>';
    if (cfg.subheading) h += '<p class="tbg__lede">' + esc(cfg.subheading) + '</p>';
    h += '</div><div class="tbg__paths">' +
      '<button type="button" class="tbg__path" data-path="new">' + this.icon('new') +
      '<span class="tbg__pathtitle">' + esc(cfg.newTitle || 'Start a new brew') + '</span>' +
      '<span class="tbg__pathsub">' + esc(cfg.newText || 'Get a starting recipe made for your coffee and gear.') + '</span><span class="tbg__go" aria-hidden="true">→</span></button>' +
      '<button type="button" class="tbg__path" data-path="fix">' + this.icon('fix') +
      '<span class="tbg__pathtitle">' + esc(cfg.fixTitle || 'Fix my cup') + '</span>' +
      '<span class="tbg__pathsub">' + esc(cfg.fixText || 'Something tastes off? Tell us what\'s happening and we\'ll find the fix.') + '</span><span class="tbg__go" aria-hidden="true">→</span></button>' +
      '</div>';

    var last = store('localStorage', LAST_KEY);
    var saved = store('localStorage', SAVED_KEY) || [];
    var extras = '';
    if (last && last.s && last.screen && Date.now() - last.at < 14 * 864e5 && last.s.method) {
      var what = last.s.path === 'fix' ? 'Fixing ' : 'Brewing ';
      var m = byId(D.METHODS, last.s.method);
      var label = last.screen === 'recipe' ? 'Your last recipe' : 'Pick up where you left off';
      extras += '<button type="button" class="tbg__resume" data-resume><span class="tbg__resumelabel">' + label + '</span><span>' + esc(what + (m ? m.label.toLowerCase() : '')) +
        (last.fx && last.fx.attempts && last.fx.attempts.length ? ' · ' + last.fx.attempts.length + ' change' + (last.fx.attempts.length === 1 ? '' : 's') + ' tried' : '') + '</span></button>';
    }
    if (saved.length) {
      extras += '<div class="tbg__saved"><div class="tbg__label">Your saved recipes</div>';
      saved.forEach(function (r, i) {
        extras += '<div class="tbg__savedrow"><button type="button" class="tbg__savedopen" data-open-saved="' + i + '"><strong>' + esc(r.title) + '</strong><span>' + esc(r.sub) + '</span></button>' +
          '<button type="button" class="tbg__x" data-del-saved="' + i + '" aria-label="Remove ' + esc(r.title) + ' from saved recipes">×</button></div>';
      });
      extras += '</div>';
    }
    if (extras) h += '<div class="tbg__extras">' + extras + '</div>';
    return h;
  };

  Guide.prototype.screen_coffee = function () {
    var self = this;
    var h = this.top('coffee') + '<h2 class="tbg__q" tabindex="-1" data-focus>Which coffee are you brewing?</h2>' +
      '<p class="tbg__hint">Pick the bag in your kitchen.</p><div class="tbg__coffees" role="list">';
    this.coffees.forEach(function (c) {
      var on = self.s.coffee === c.handle;
      var notes = splitNotes(c.notes).join(' · ');
      h += '<div role="listitem"><button type="button" class="tbg__coffee' + (on ? ' is-on' : '') + '" data-pick="' + esc(c.handle) + '" aria-pressed="' + on + '">' +
        (c.image ? '<img src="' + esc(c.image) + '" alt="" width="300" height="300" loading="lazy">' : '<span class="tbg__noimg"></span>') +
        '<span class="tbg__coffeename">' + esc(c.title) + '</span>' + (notes ? '<span class="tbg__coffeenotes">' + esc(notes) + '</span>' : '') + '</button></div>';
    });
    var on = this.s.coffee === 'other';
    h += '<div role="listitem"><button type="button" class="tbg__coffee is-other' + (on ? ' is-on' : '') + '" data-pick="other" aria-pressed="' + on + '">' +
      '<span class="tbg__noimg">' + this.icon('fix') + '</span><span class="tbg__coffeename">Something else</span><span class="tbg__coffeenotes">Another roaster, or an older bag of ours</span></button></div>';
    return h + '</div>';
  };
  Guide.prototype.screen_roast = function () {
    return this.question('roast', 'How is it roasted?', 'The bag usually says. If not, go with your best guess.', D.ROASTS, this.s.roast);
  };
  Guide.prototype.screen_method = function () {
    var self = this;
    var opts = D.METHODS.map(function (m) {
      return { id: m.id, label: m.label, sub: m.sub, icon: self.icon(m.icon), badge: self.isRecommended(m.id) ? 'Roaster pick' : '' };
    });
    var c = this.coffee();
    var hint = c && c.brew.recommended && c.brew.recommended.length ? 'Marked "Roaster pick" where ' + c.title + ' really shines.' : '';
    return this.question('method', this.s.path === 'fix' ? 'How are you brewing it?' : 'How do you want to brew it?', hint, opts, this.s.method, true);
  };
  Guide.prototype.screen_machine = function () {
    return this.question('machine', 'Which espresso machine do you have?', 'Close enough counts. This helps us suggest the right dose.', D.MACHINES, this.s.machine);
  };
  Guide.prototype.screen_basket = function () {
    return this.question('basket', 'Flip your filter basket over. What do you see?', 'This tells us how forgiving your setup is.', D.BASKETS, this.s.basket);
  };
  Guide.prototype.screen_grinder = function () {
    return this.question('grinder', 'How do you grind your coffee?', '', D.GRINDERS, this.s.grinder);
  };
  Guide.prototype.screen_brewer = function () {
    return this.question('brewer', 'Which dripper are you using?', 'Each one likes a slightly different pour.', D.BREWERS, this.s.brewer);
  };
  Guide.prototype.symptomList = function () {
    var m = this.s.method;
    return D.SYMPTOMS.filter(function (x) {
      if (x.only && x.only.indexOf(m) === -1) return false;
      if (x.methods && !x.methods[m]) return false;
      return true;
    }).map(function (x) {
      return x.methods ? { id: x.id, label: x.methods[m][0], sub: x.methods[m][1] } : x;
    });
  };
  Guide.prototype.symptomLabel = function (id) {
    var x = byId(this.symptomList(), id);
    return x ? x.label : '';
  };
  Guide.prototype.screen_symptom = function () {
    return this.question('symptom', 'What\'s going on with your cup?', 'Pick the one that bugs you most.', this.symptomList(), this.s.symptom, true);
  };

  Guide.prototype.screen_details = function () {
    var cfg = D.DETAILS[this.s.method], d = this.s.d, self = this;
    var h = this.top('details') + '<h2 class="tbg__q" tabindex="-1" data-focus>Got any numbers?</h2>' +
      '<p class="tbg__hint">Totally optional. Even one helps us give a sharper answer.</p><form class="tbg__form" data-details novalidate>';
    cfg.fields.forEach(function (f) {
      var id = 'tbg-' + self.root.id + '-' + f.id;
      if (f.tempChips) {
        h += '<fieldset class="tbg__field"><legend class="tbg__fieldlabel">' + esc(f.label) + '</legend><div class="tbg__chips">' +
          D.TEMP_CHIPS.map(function (c) { var on = d.temp === c.id; return '<button type="button" class="tbg__chip' + (on ? ' is-on' : '') + '" data-chip="temp" data-val="' + c.id + '" aria-pressed="' + on + '">' + esc(c.label) + '</button>'; }).join('') +
          '</div></fieldset>';
        return;
      }
      h += '<div class="tbg__field"><label class="tbg__fieldlabel" for="' + id + '">' + esc(f.label) + '</label>' +
        '<div class="tbg__inputwrap"><input id="' + id + '" name="' + f.id + '" type="text" inputmode="' + (f.mmss ? 'text' : 'decimal') + '" autocomplete="off" placeholder="e.g. ' + esc(f.ph) + '" value="' + esc(d[f.id] || '') + '">' +
        '<span class="tbg__unit">' + esc(f.unit) + '</span></div>';
      if (f.hint) h += '<div class="tbg__fieldhint">' + esc(f.hint) + '</div>';
      if (f.chips) {
        h += '<div class="tbg__chips" aria-label="Or pick one">' + D.TIME_CHIPS.map(function (c) {
          var on = d.timeChip === c.id;
          return '<button type="button" class="tbg__chip' + (on ? ' is-on' : '') + '" data-chip="timeChip" data-val="' + c.id + '" aria-pressed="' + on + '">' + esc(c.label) + '</button>';
        }).join('') + '</div>';
      }
      h += '</div>';
    });
    h += '<div class="tbg__actions"><button type="submit" class="tbg__btn">Show me what to try</button>' +
      '<button type="button" class="tbg__link" data-skip>Skip, I\'m not sure</button></div></form>';
    return h;
  };

  Guide.prototype.recipeHead = function () {
    var c = this.coffee();
    var sub = [this.methodLabel(), this.equipLabel()].filter(Boolean).join(' · ');
    return '<div class="tbg__rhead">' + (c && c.image ? '<img class="tbg__rimg" src="' + esc(c.image) + '" alt="" width="300" height="300">' : '<span class="tbg__rimg tbg__noimg">' + this.icon(this.s.method) + '</span>') +
      '<div><div class="tbg__eyebrow">' + esc(sub) + '</div><h2 class="tbg__rtitle" tabindex="-1" data-focus>' + esc(this.coffeeName()) + '</h2></div></div>';
  };

  Guide.prototype.screen_recipe = function () {
    var r = this.recipe(), sz = this.sizeCfg(), note = this.roasterNote();
    var h = '<div class="tbg__top"><button type="button" class="tbg__back" data-back><span aria-hidden="true">←</span> Back</button></div>';
    h += '<article class="tbg__card tbg__recipe">' + this.recipeHead();
    h += '<div class="tbg__source' + (r.tested ? ' is-tested' : '') + '">' + (r.tested
      ? '<strong>Dialed in by our roasters.</strong> This is the recipe we use for this coffee.'
      : '<strong>Your starting recipe.</strong> Built on proven brewing ratios' + (this.s.coffee !== 'other' || this.s.roast !== 'unknown' ? ' and adjusted for this roast' : '') + '. Taste, then tweak.') + '</div>';
    if (note) h += '<div class="tbg__note"><span class="tbg__label">From our roasters</span>' + esc(note) + '</div>';
    if (this.savedTweaks && this.savedTweaks.length) h += '<div class="tbg__note"><span class="tbg__label">Your tweaks</span>' + this.savedTweaks.map(esc).join(' · ') + '</div>';
    if (sz) {
      h += '<div class="tbg__size"><span class="tbg__label" id="tbg-size-' + this.root.id + '">' + esc(sz.label) + '</span><div class="tbg__stepper" role="group" aria-labelledby="tbg-size-' + this.root.id + '">' +
        '<button type="button" data-size="-1" aria-label="Less"' + (r.size <= sz.min ? ' disabled' : '') + '>−</button><output aria-live="polite">' + esc(sz.unit(r.size)) + '</output>' +
        '<button type="button" data-size="1" aria-label="More"' + (r.size >= sz.max ? ' disabled' : '') + '>+</button></div></div>';
    }
    h += '<dl class="tbg__stats">' + r.stats.map(function (st) {
      return '<div class="tbg__stat"><dt>' + esc(st.label) + '</dt><dd>' + esc(st.value) + (st.sub ? '<span>' + esc(st.sub) + '</span>' : '') + '</dd></div>';
    }).join('') + '</dl>';
    if (r.adjustNote) h += '<p class="tbg__adjust">' + esc(r.adjustNote) + '</p>';
    h += '<h3 class="tbg__h3">How to brew it</h3><ol class="tbg__steps">' + r.steps.map(function (st) { return '<li>' + esc(st) + '</li>'; }).join('') + '</ol>';
    if (r.tips.length) h += '<details class="tbg__tips"><summary>Tips for this method</summary><ul>' + r.tips.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul></details>';
    h += '<div class="tbg__btnrow"><button type="button" class="tbg__btn" data-save>Save my recipe</button><button type="button" class="tbg__btn is-ghost" data-copy>Copy recipe</button>' +
      '<button type="button" class="tbg__btn is-ghost" data-share>Share link</button></div>';
    h += '<p class="tbg__status" role="status" data-status></p></article>';
    h += '<div class="tbg__after"><button type="button" class="tbg__nudge" data-to-fix><strong>Brewed it and something\'s off?</strong><span>Let\'s figure it out together →</span></button></div>';
    h += this.productLine() + '<button type="button" class="tbg__link tbg__restart" data-restart>Start over</button>';
    return h;
  };

  /* ---------- troubleshooting engine ---------- */
  Guide.prototype.flags = function () {
    var s = this.s, d = s.d, cfg = D.DETAILS[s.method] || {}, f = {};
    var dose = num(d.dose), out = num(d.out), water = num(d.water), steep = num(d.steep);
    var ratio = null;
    if (s.method === 'espresso' && dose && out) ratio = out / dose;
    else if (dose && water) ratio = water / dose;
    if (ratio && cfg.ratio) { f.ratioLow = ratio < cfg.ratio[0]; f.ratioHigh = ratio > cfg.ratio[1]; }
    f.numbersKnown = !!(dose && (out || water));

    var t = null, range = null;
    if (s.method === 'espresso') { t = num(d.time); range = cfg.time; }
    if (s.method === 'pourover') { t = parseTime(d.time); range = cfg.timeBy[s.brewer || 'other'] || cfg.timeBy.other; }
    if (t && range) { f.fast = t < range[0]; f.slow = t > range[1]; }
    else if (d.timeChip === 'fast') f.fast = true;
    else if (d.timeChip === 'slow') f.slow = true;
    if (s.symptom === 'fast') f.fast = true;
    if (s.symptom === 'slow') f.slow = true;

    if (steep && cfg.steep) { f.steepShort = steep < cfg.steep[0]; f.steepLong = steep > cfg.steep[1]; }
    f.tempHot = d.temp === 'hot';
    f.tempCool = d.temp === 'cool';

    var m = this.machine();
    if (s.method === 'espresso' && dose && m) { f.doseHigh = dose > m.dose + 2; f.doseLow = dose < m.dose - 3; }
    var b = D.roastBucket(this.roastValue());
    f.light = b === 'light'; f.dark = b === 'dark';
    var g = this.grinder();
    f.preground = g === 'preground'; f.blade = g === 'blade'; f.builtin = g === 'builtin';
    f.burr = g === 'burr' || g === 'builtin';
    f.canGrind = g !== 'preground';
    f.pressurized = s.basket === 'pressurized';
    f.chemex = s.brewer === 'chemex';
    return f;
  };
  Guide.prototype.ctx = function () {
    var d = this.s.d, rec = this.recipe();
    return {
      method: this.s.method, machine: this.machine(), grinder: this.grinder(), brewer: this.s.brewer,
      recipe: rec.numbers, flags: this.flags(),
      d: { dose: num(d.dose), out: num(d.out), water: num(d.water) }
    };
  };
  function conds(list, f) {
    return (list || []).every(function (c) { return c.charAt(0) === '!' ? !f[c.slice(1)] : !!f[c]; });
  }
  Guide.prototype.blockedDir = function (dir) {
    if (!dir) return false;
    var p = dir.split(':'), opp = OPP[p[1]];
    if (!opp) return false;
    return this.fx.dirs.indexOf(p[0] + ':' + opp) !== -1;
  };
  Guide.prototype.pickFix = function () {
    var self = this, f = this.flags();
    var rules = ((D.RULES[this.s.method] || {})[this.s.symptom] || []).concat(D.FALLBACKS);
    var best = null;
    rules.forEach(function (r) {
      var fix = D.FIXES[r[0]];
      if (!fix || self.fx.tried[r[0]]) return;
      if (!conds(r[2], f) || self.blockedDir(fix.dir)) return;
      if (!best || r[1] > best[1]) best = r;
    });
    return best ? best[0] : null;
  };
  Guide.prototype.startFix = function () {
    if (this.fx.attempts.length === 0 && !this.fx.current) track('brew_guide_troubleshooting_started', this.evt({ symptom: this.s.symptom }));
    this.nextFix();
  };
  Guide.prototype.nextFix = function () {
    this.fx.repeat = false;
    this.fx.split = null;
    var opts = { replace: this.inLoop() };
    if (this.fx.attempts.length >= D.MAX_ATTEMPTS) return this.go('stop', opts);
    var id = this.pickFix();
    if (!id) return this.go('stop', opts);
    this.fx.current = id;
    this.go('fix', opts);
  };
  // Once troubleshooting starts, each new suggestion replaces the last one in history,
  // so Back returns to your answers instead of stepping through every past suggestion.
  Guide.prototype.inLoop = function () { return ['fix', 'changed'].indexOf(this.screen) !== -1; };
  Guide.prototype.currentFix = function () {
    if (this.fx.split) return this.splitFix(this.fx.split);
    return D.FIXES[this.fx.current];
  };
  Guide.prototype.splitFix = function (sp) {
    var group = sp.dir.split(':')[0];
    var what = { grind: 'grinder setting', ratio: 'recipe', temp: 'water temperature', steep: 'steep time', pace: 'pour speed' }[group] || 'setting';
    var steps = ['Set your ' + what + ' halfway between where you started and where you are now.'];
    if (group === 'grind') steps.push('If your grinder doesn\'t have an in-between setting, go back one step.');
    steps.push('Brew and taste.');
    return {
      title: 'Split the difference',
      why: 'It went from ' + sp.from.toLowerCase() + ' to ' + sp.to.toLowerCase() + ', which means the sweet spot is right in between. You\'re close.',
      steps: steps
    };
  };

  Guide.prototype.screen_fix = function () {
    var fix = this.currentFix();
    var c = this.ctx();
    var steps = typeof fix.steps === 'function' ? fix.steps(c) : fix.steps;
    var n = this.fx.attempts.length + 1;
    var eyebrow = this.fx.split ? 'Almost there' : (this.fx.repeat ? 'Same idea, one more step' : (n === 1 ? 'Here\'s where we\'d start' : 'Try this next'));
    var h = '<div class="tbg__top"><button type="button" class="tbg__back" data-back><span aria-hidden="true">←</span> Back</button>' +
      '<span class="tbg__count">Change ' + n + '</span></div>' + this.summary('fix');
    h += '<article class="tbg__card tbg__fix"><div class="tbg__eyebrow">' + esc(eyebrow) + '</div>' +
      '<h2 class="tbg__rtitle" tabindex="-1" data-focus>' + esc(fix.title) + '</h2>' +
      '<p class="tbg__why">' + esc(fix.why) + '</p><ol class="tbg__steps">' + steps.map(function (st) { return '<li>' + esc(st) + '</li>'; }).join('') + '</ol>' +
      '<p class="tbg__keep">Keep everything else the same, so you can taste what changed.</p></article>';
    h += '<div class="tbg__feedback"><h3 class="tbg__h3">Brewed it? How\'d it go?</h3><div class="tbg__opts">' +
      '<button type="button" class="tbg__opt" data-fb="yes"><span class="tbg__optbody"><span class="tbg__optlabel">That did it</span><span class="tbg__optsub">Tastes great now</span></span></button>' +
      '<button type="button" class="tbg__opt" data-fb="better"><span class="tbg__optbody"><span class="tbg__optlabel">Better, but not quite there</span></span></button>' +
      '<button type="button" class="tbg__opt" data-fb="same"><span class="tbg__optbody"><span class="tbg__optlabel">No real difference</span></span></button>' +
      '<button type="button" class="tbg__opt" data-fb="changed"><span class="tbg__optbody"><span class="tbg__optlabel">Now it tastes different</span><span class="tbg__optsub">Like it went too far the other way</span></span></button>' +
      '</div></div>';
    h += '<details class="tbg__tips tbg__base"><summary>See the full starting recipe</summary>' + this.miniRecipe() + '</details>';
    return h;
  };
  Guide.prototype.miniRecipe = function () {
    var r = this.recipe();
    return '<dl class="tbg__stats is-mini">' + r.stats.map(function (st) { return '<div class="tbg__stat"><dt>' + esc(st.label) + '</dt><dd>' + esc(st.value) + '</dd></div>'; }).join('') + '</dl>' +
      '<ol class="tbg__steps">' + r.steps.map(function (st) { return '<li>' + esc(st) + '</li>'; }).join('') + '</ol>';
  };

  Guide.prototype.screen_changed = function () {
    var self = this;
    var opts = this.symptomList().filter(function (x) { return x.id !== 'other' && x.id !== self.s.symptom; });
    var h = '<div class="tbg__top"><button type="button" class="tbg__back" data-back><span aria-hidden="true">←</span> Back</button></div>';
    h += '<h2 class="tbg__q" tabindex="-1" data-focus>What\'s it tasting like now?</h2><p class="tbg__hint">That\'s useful. It tells us which way to go.</p><div class="tbg__opts is-grid">';
    opts.forEach(function (o) {
      h += '<button type="button" class="tbg__opt" data-new-sym="' + o.id + '"><span class="tbg__optbody"><span class="tbg__optlabel">' + esc(o.label) + '</span>' + (o.sub ? '<span class="tbg__optsub">' + esc(o.sub) + '</span>' : '') + '</span></button>';
    });
    return h + '</div>';
  };

  Guide.prototype.changesMade = function () {
    return this.fx.attempts.map(function (a) { return a.title + (a.outcome === 'same' ? ' (no change)' : ''); })
      .filter(function (x, i, arr) { return arr.indexOf(x) === i; });
  };

  Guide.prototype.screen_success = function () {
    var helped = this.fx.attempts.filter(function (a) { return a.outcome === 'yes' || a.outcome === 'better'; }).map(function (a) { return a.title; });
    var h = '<article class="tbg__card tbg__done">' + this.recipeHead() +
      '<h3 class="tbg__h3">That\'s your cup now.</h3><p class="tbg__why">Nice work. Write down what you changed so you can brew it the same way tomorrow. Or save it here.</p>';
    if (helped.length) h += '<div class="tbg__note"><span class="tbg__label">What made the difference</span><ul class="tbg__plain">' + helped.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul></div>';
    h += '<div class="tbg__btnrow"><button type="button" class="tbg__btn" data-save>Save my recipe</button><button type="button" class="tbg__btn is-ghost" data-copy>Copy recipe</button></div>' +
      '<p class="tbg__status" role="status" data-status></p></article>';
    h += this.productLine() + '<button type="button" class="tbg__link tbg__restart" data-restart>Start over</button>';
    return h;
  };

  Guide.prototype.screen_stop = function () {
    var tried = this.changesMade();
    var url = this.cfg.contactUrl || '/pages/contact';
    var h = '<div class="tbg__top"><button type="button" class="tbg__back" data-back><span aria-hidden="true">←</span> Back</button></div>';
    h += '<article class="tbg__card tbg__done"><div class="tbg__eyebrow">Still not right?</div><h2 class="tbg__rtitle" tabindex="-1" data-focus>Let\'s get a second set of eyes on it.</h2>' +
      '<p class="tbg__why">When a few solid changes haven\'t done it, the cause is usually something we can\'t see from here: the grinder, the machine, the water or the beans themselves. Send us a note with what you\'re brewing and what you\'ve tried. We\'re always happy to help.</p>';
    if (tried.length) h += '<div class="tbg__note"><span class="tbg__label">What we\'ve tried so far</span><ul class="tbg__plain">' + tried.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul></div>';
    h += '<div class="tbg__btnrow"><a class="tbg__btn" href="' + esc(url) + '" data-contact>Message our team</a><button type="button" class="tbg__btn is-ghost" data-copy-summary>Copy this summary</button></div>' +
      '<p class="tbg__status" role="status" data-status></p></article>';
    h += '<button type="button" class="tbg__link tbg__restart" data-restart>Start over</button>';
    return h;
  };

  Guide.prototype.productLine = function () {
    var c = this.coffee(), m = this.s.method, self = this;
    if (c && c.available && c.url) {
      return '<p class="tbg__product">Running low on ' + esc(c.title) + '? <a href="' + esc(c.url) + '" data-product="' + esc(c.handle) + '">Grab another bag</a></p>';
    }
    if (!c) {
      var pick = this.coffees.filter(function (x) { return x.available && x.brew.recommended && x.brew.recommended.indexOf(m) !== -1; })[0];
      if (pick) return '<p class="tbg__product">Looking for a coffee that shines as ' + esc(self.methodLabel().toLowerCase()) + '? Try <a href="' + esc(pick.url) + '" data-product="' + esc(pick.handle) + '">' + esc(pick.title) + '</a>.</p>';
      if (this.cfg.shopUrl) return '<p class="tbg__product">Ready for your next bag? <a href="' + esc(this.cfg.shopUrl) + '" data-product="collection">Browse our coffees</a></p>';
    }
    return '';
  };

  /* ---------- recipe text, save, share ---------- */
  Guide.prototype.recipeText = function () {
    var r = this.recipe(), lines = [];
    lines.push(this.coffeeName() + ': ' + [this.methodLabel(), this.equipLabel()].filter(Boolean).join(', '));
    r.stats.forEach(function (st) { lines.push(st.label + ': ' + st.value + (st.sub ? ' (' + st.sub + ')' : '')); });
    lines.push('');
    r.steps.forEach(function (st, i) { lines.push((i + 1) + '. ' + st); });
    var helped = this.fx.attempts.filter(function (a) { return a.outcome === 'yes' || a.outcome === 'better'; }).map(function (a) { return a.title; });
    var tweaks = helped.length ? helped : (this.savedTweaks || []);
    if (tweaks.length) { lines.push(''); lines.push('My tweaks: ' + tweaks.join('; ')); }
    lines.push(''); lines.push('From the Tapestry Coffee brew guide: ' + this.shareUrl());
    return lines.join('\n');
  };
  Guide.prototype.copy = function (text, msg) {
    var self = this;
    var done = function () { self.status(msg || 'Copied.'); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function () { self.fallbackCopy(text); done(); });
    } else { this.fallbackCopy(text); done(); }
  };
  Guide.prototype.fallbackCopy = function (text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  };
  Guide.prototype.status = function (msg) {
    var el = $(this.view, '[data-status]');
    if (el) { el.textContent = msg; clearTimeout(this._st); this._st = setTimeout(function () { el.textContent = ''; }, 3500); }
  };
  Guide.prototype.save = function () {
    var saved = store('localStorage', SAVED_KEY) || [];
    var s = this.s;
    var tweaks = this.fx.attempts.filter(function (a) { return a.outcome === 'yes' || a.outcome === 'better'; }).map(function (a) { return a.title; });
    if (!tweaks.length && this.savedTweaks) tweaks = this.savedTweaks;
    var entry = {
      key: [s.coffee, s.roast, s.method, s.machine, s.brewer, s.size].join('|'),
      title: this.coffeeName(), sub: [this.methodLabel(), this.equipLabel()].filter(Boolean).join(' · ') + (tweaks.length ? ' · with your tweaks' : ''),
      s: { coffee: s.coffee, roast: s.roast, method: s.method, machine: s.machine, brewer: s.brewer, size: s.size }, tweaks: tweaks, at: Date.now()
    };
    saved = saved.filter(function (x) { return x.key !== entry.key; });
    saved.unshift(entry);
    store('localStorage', SAVED_KEY, saved.slice(0, 6));
    this.status('Saved. You\'ll find it here next time on this device.');
    track('brew_guide_recipe_saved', this.evt());
  };
  Guide.prototype.share = function () {
    var url = this.shareUrl();
    track('brew_guide_recipe_shared', this.evt());
    if (navigator.share) {
      navigator.share({ title: this.coffeeName() + ' · ' + this.methodLabel(), url: url }).catch(function () {});
    } else this.copy(url, 'Link copied.');
  };
  Guide.prototype.evt = function (extra) {
    var s = this.s;
    return Object.assign({ path: s.path || '', coffee: s.coffee || '', method: s.method || '', equipment: s.machine || s.brewer || '' }, extra || {});
  };

  /* ---------- events ---------- */
  Guide.prototype.wire = function (screen) {
    var self = this, v = this.view;
    $$(v, '[data-back]').forEach(function (b) { b.addEventListener('click', function () { self.back(); }); });
    $$(v, '[data-jump]').forEach(function (b) { b.addEventListener('click', function () { self.go(b.getAttribute('data-jump')); }); });
    $$(v, '[data-restart]').forEach(function (b) { b.addEventListener('click', function () { self.restart(); }); });

    if (screen === 'home') {
      $$(v, '[data-path]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!self.started) { self.started = true; track('brew_guide_started', {}); }
          var keepCoffee = self.prefilled && self.prefilled.coffee ? self.s.coffee : null;
          var path = b.getAttribute('data-path');
          if (self.s.path && self.s.path !== path) { var c = self.s.coffee; self.reset(); self.s.coffee = keepCoffee || c; }
          if (keepCoffee) self.s.coffee = keepCoffee;
          self.s.path = path;
          track('brew_guide_path_selected', { path: path });
          self.go(self.firstOpen() === 'fix' ? 'symptom' : self.firstOpen());
        });
      });
      var res = $(v, '[data-resume]');
      if (res) res.addEventListener('click', function () {
        var last = store('localStorage', LAST_KEY);
        if (!last) return;
        self.s = Object.assign(self.s, last.s); self.fx = Object.assign(self.fx, last.fx || {});
        self.goPath(last.screen);
      });
      $$(v, '[data-open-saved]').forEach(function (b) {
        b.addEventListener('click', function () {
          var saved = store('localStorage', SAVED_KEY) || [], e = saved[+b.getAttribute('data-open-saved')];
          if (!e) return;
          self.reset();
          Object.keys(e.s).forEach(function (k) { self.s[k] = e.s[k]; });
          self.s.path = 'new';
          self.savedTweaks = e.tweaks || [];
          self.go('recipe');
        });
      });
      $$(v, '[data-del-saved]').forEach(function (b) {
        b.addEventListener('click', function () {
          var saved = store('localStorage', SAVED_KEY) || [];
          saved.splice(+b.getAttribute('data-del-saved'), 1);
          store('localStorage', SAVED_KEY, saved);
          self.render('home');
        });
      });
      return;
    }

    $$(v, '[data-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        var val = b.getAttribute('data-pick');
        $$(v, '[data-pick]').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
        setTimeout(function () { self.answer(screen, val); }, 140);
      });
    });

    if (screen === 'details') {
      var form = $(v, '[data-details]');
      $$(v, '[data-chip]').forEach(function (b) {
        b.addEventListener('click', function () {
          var key = b.getAttribute('data-chip'), val = b.getAttribute('data-val');
          var on = self.s.d[key] !== val;
          self.s.d[key] = on ? val : null;
          $$(v, '[data-chip="' + key + '"]').forEach(function (x) { var y = on && x === b; x.classList.toggle('is-on', y); x.setAttribute('aria-pressed', y); });
        });
      });
      var collect = function () {
        $$(form, 'input').forEach(function (i) { self.s.d[i.name] = i.value.trim(); });
        self.s.dSeen = true;
      };
      form.addEventListener('submit', function (e) {
        e.preventDefault(); collect();
        var given = Object.keys(self.s.d).filter(function (k) { return self.s.d[k]; });
        track('brew_guide_question_answered', self.evt({ question: 'details', answer: given.join(',') || 'none' }));
        self.next('details');
      });
      $(v, '[data-skip]').addEventListener('click', function () {
        collect();
        track('brew_guide_question_answered', self.evt({ question: 'details', answer: 'skipped' }));
        self.next('details');
      });
    }

    if (screen === 'recipe' || screen === 'success') {
      if (screen === 'recipe' && !this._viewedKey) {
        this._viewedKey = true;
        track('brew_guide_recipe_viewed', this.evt({ tested: this.recipe().tested ? 'yes' : 'no' }));
        track('brew_guide_completed', this.evt({ outcome: 'recipe' }));
      }
      $$(v, '[data-size]').forEach(function (b) {
        b.addEventListener('click', function () {
          var sz = self.sizeCfg(), cur = self.recipe().size;
          self.s.size = Math.min(Math.max(cur + Number(b.getAttribute('data-size')), sz.min), sz.max);
          try { history.replaceState({ tbg: self.stack.length }, '', self.urlFor('recipe')); } catch (e) {}
          self.render('recipe');
          var again = $(self.view, '[data-size="' + b.getAttribute('data-size') + '"]');
          if (again && !again.disabled) again.focus(); else { var o = $(self.view, '.tbg__stepper output'); if (o) o.focus(); }
        });
      });
      var sv = $(v, '[data-save]'); if (sv) sv.addEventListener('click', function () { self.save(); });
      var cp = $(v, '[data-copy]'); if (cp) cp.addEventListener('click', function () { self.copy(self.recipeText(), 'Recipe copied.'); track('brew_guide_recipe_copied', self.evt()); });
      var sh = $(v, '[data-share]'); if (sh) sh.addEventListener('click', function () { self.share(); });
      var tf = $(v, '[data-to-fix]');
      if (tf) tf.addEventListener('click', function () {
        self.s.path = 'fix'; self.s.symptom = null; self.s.d = {}; self.s.dSeen = false; self.resetFix();
        track('brew_guide_path_selected', { path: 'fix', from: 'recipe' });
        self.go(self.firstOpen());
      });
    }

    if (screen === 'fix') {
      track('brew_guide_recommendation_viewed', this.evt({ symptom: this.s.symptom, fix: this.fx.split ? 'split' : this.fx.current, attempt: this.fx.attempts.length + 1 }));
      $$(v, '[data-fb]').forEach(function (b) { b.addEventListener('click', function () { self.feedback(b.getAttribute('data-fb')); }); });
    }
    if (screen === 'changed') {
      $$(v, '[data-new-sym]').forEach(function (b) { b.addEventListener('click', function () { self.newSymptom(b.getAttribute('data-new-sym')); }); });
    }
    if (screen === 'stop') {
      track('brew_guide_completed', this.evt({ outcome: 'needs_help', attempts: this.fx.attempts.length }));
      var cs = $(v, '[data-copy-summary]');
      if (cs) cs.addEventListener('click', function () {
        var txt = 'Brewing: ' + self.coffeeName() + ', ' + [self.methodLabel(), self.equipLabel()].filter(Boolean).join(', ') +
          '\nProblem: ' + self.symptomLabel(self.s.symptom) + '\nTried: ' + self.changesMade().join('; ');
        self.copy(txt, 'Summary copied. Paste it into your message.');
      });
      var ct = $(v, '[data-contact]'); if (ct) ct.addEventListener('click', function () { track('brew_guide_contact_clicked', self.evt()); });
    }
    $$(v, '[data-product]').forEach(function (a) { a.addEventListener('click', function () { track('brew_guide_product_clicked', self.evt({ product: a.getAttribute('data-product') })); }); });
  };

  Guide.prototype.answer = function (screen, val) {
    var s = this.s;
    var prev = s[screen];
    s[screen] = val;
    if (screen === 'coffee') {
      if (val !== 'other') s.roast = null;
      track('brew_guide_coffee_selected', { coffee: val });
      this._viewedKey = false;
    } else if (screen === 'method') {
      if (prev !== val) { s.machine = null; s.basket = null; s.brewer = null; s.symptom = null; s.d = {}; s.dSeen = false; s.size = null; this.resetFix(); }
      track('brew_guide_method_selected', { method: val, coffee: s.coffee || '' });
      this._viewedKey = false;
    } else {
      if (prev !== val && ['machine', 'basket', 'grinder', 'brewer', 'symptom'].indexOf(screen) !== -1) {
        this.resetFix();
        if (screen === 'brewer' || screen === 'machine') s.size = null;
        this._viewedKey = false;
      }
      track('brew_guide_question_answered', this.evt({ question: screen, answer: val }));
    }
    this.savedTweaks = null;
    if (this.prefilled) this.prefilled[screen] = false;
    this.next(screen);
  };

  Guide.prototype.feedback = function (outcome) {
    var fix = this.currentFix(), id = this.fx.split ? 'split' : this.fx.current;
    track('brew_guide_feedback_submitted', this.evt({ symptom: this.s.symptom, fix: id, outcome: outcome, attempt: this.fx.attempts.length + 1 }));
    this.fx.attempts.push({ id: id, title: fix.title, outcome: outcome, symptom: this.s.symptom });
    if (!this.fx.split) {
      this.fx.tried[id] = true;
      var dir = D.FIXES[id].dir;
      if (dir && this.fx.dirs.indexOf(dir) === -1) this.fx.dirs.push(dir);
    }
    if (outcome === 'yes') {
      track('brew_guide_completed', this.evt({ outcome: 'fixed', attempts: this.fx.attempts.length }));
      return this.go('success', { replace: true });
    }
    if (outcome === 'better' && !this.fx.split) {
      var rep = this.fx.repeats[id] || 0;
      if (D.FIXES[id].repeat && rep < D.FIXES[id].repeat && this.fx.attempts.length < D.MAX_ATTEMPTS) {
        this.fx.repeats[id] = rep + 1;
        this.fx.repeat = true;
        return this.go('fix', { replace: true });
      }
    }
    if (outcome === 'changed') return this.go('changed', { replace: true });
    this.nextFix();
  };

  Guide.prototype.newSymptom = function (sym) {
    var cur = byId(D.SYMPTOMS, this.s.symptom);
    var last = this.fx.attempts[this.fx.attempts.length - 1];
    var lastDir = last && D.FIXES[last.id] && D.FIXES[last.id].dir;
    var fromLabel = this.symptomLabel(this.s.symptom), toLabel = this.symptomLabel(sym);
    track('brew_guide_question_answered', this.evt({ question: 'new_symptom', answer: sym, previous: this.s.symptom }));
    this.s.symptom = sym;
    if (cur && cur.opposite === sym && lastDir && this.fx.attempts.length < D.MAX_ATTEMPTS) {
      this.fx.split = { dir: lastDir, from: fromLabel, to: toLabel };
      this.fx.repeat = false;
      return this.go('fix', { replace: true });
    }
    this.nextFix();
  };

  Guide.prototype.restart = function () {
    var keep = this.prefilled && this.prefilled.coffee ? this.s.coffee : null;
    this.reset();
    this.savedTweaks = null;
    this._viewedKey = false;
    store('localStorage', LAST_KEY, null);
    if (keep) { this.s.coffee = keep; this.prefilled = { coffee: true }; } else this.prefilled = {};
    this.keepParams = keep ? '?coffee=' + encodeURIComponent(keep) : '';
    this.stack = [];
    this.go('home');
  };

  function init() {
    $$(document, '[data-tbg]').forEach(function (el) {
      if (el.__tbg) return;
      el.__tbg = new Guide(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
